import NoDataFound from 'components/Common/NoDataFound';
import TableContainer from 'components/Common/TableContainer';
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { getAllBooking, getBookingBYContainerWiseSuccess, getByBookingNoSuccess } from 'store/actions';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Skeleton from "react-loading-skeleton"; 
import TableSkeleton from 'components/Common/TableSkeleton';

const BookingList = () => {
    const getRole = JSON.parse(localStorage.getItem("authUser"));
    const dispatch = useDispatch();
    const booking = useSelector(state => ({
        booking: state.GetAllBookings.booking.booking
    }), shallowEqual)
    const [data, setData] = useState(booking)
    const getAllBookings = () => {
        dispatch(getAllBooking())
    }
    const history = useHistory();
    useEffect(() => {
        getAllBookings()
    }, [])
    useEffect(() => {
        if (booking !== undefined) {
            setData(booking)
        }
    }, [data, booking])
    useEffect(() => {
        dispatch(getByBookingNoSuccess([]))
        dispatch(getBookingBYContainerWiseSuccess([]))
    }, [])

    const columns = React.useMemo(
        () => [
            {
                Header: () => null,
                id: "expander",
                Cell: ({ row }) => (
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? <i className="bx bx bx-chevron-up"></i> : <i className="bx bx bx-chevron-down"></i>}
                    </span>
                )
            },
            {
                Header: "Client code",
                accessor: "customerCode", //need hide when client login
                id: "clientCode",
            },
            {
                accessor: 'customerName',
                Header: 'Client name',  //need hide when client login
                id: 'clientName',
            },
            {
                accessor: 'division',
                Header: 'Division',
            },
            {
                accessor: 'portOfLoading',
                Header: 'Port of loading',
            },
            {
                accessor: 'portOfDischarge',
                Header: 'Port of discharge',
            },
            {
                accessor: 'BL_Number',
                Header: 'Glottis BL/AWB',
            },
            {
                accessor: 'carrierName',
                Header: 'Carrier name',
            },
            {
                accessor: 'carrier_BL_number',
                Header: 'Carrier BL/AWB',
            },
            {
                accessor: (row) => {
                    return row.containerDetails.map((a) => a.containerNo).join(" ")
                },
                Header: "Actions",
                Cell: ({ row }) => {
                    return <Button
                        color="secondary"
                        className="btn-sm btn-draft"
                        onClick={() => {
                            history.push(`/bookings/track/${row.original.BL_Number}`)
                        }}
                    >
                        Track
                    </Button>
                }
            },
            {
                accessor: ' ',
                Header: ' ',
            },
        ],
        []
    );
    const expandedRows = React.useMemo(() => {
        if (data?.booking) {
            let arr;
            let d = data?.booking;
            if (d.length > 0) {
                arr = d.map((sid, ind) => {
                    return { [ind]: true };
                });
            }
            return arr;
        }
    }, []);

    const subTable = (row) => {
        return row.original.containerDetails?.length > 0 ? (
            <div className='collapse-row sub-table'>
                <div className='collapse-heading'>
                    <h5>Container No</h5>
                    <h5>Actions</h5>
                </div>
                {row.original.containerDetails.map((list, idx) => (
                    <div key={list._id} className='collapse-data'>
                        <p>{list.containerNo}</p>
                        <p>
                            <Button
                                color="secondary"
                                className=" btn-sm btn-draft"
                                onClick={() => {
                                    history.push(`/bookings/track/${list.BL_Number}/${list.containerNo}`)
                                }}
                            >
                                Track
                            </Button>
                        </p>
                    </div>
                ))
                }
            </div >
        ) : <p className='m-0 p-5 text-center sub-table'>No more data</p>
    }
    document.title = "Bookings | Glottis Logistics";
 
    return (
        <div className="page-content booking">
            <div className="container-fluid booking-list accordion-style ">
                <Breadcrumbs title="Dashboard" dashurl="/dashboard" breadcrumbItem="Bookings" />            
                {!data?.booking ? <>
                    <div className='mb-2 p-3'>
                    <Skeleton height={"53px"} width={'180px'} />
                    </div>
                    <TableSkeleton datacount={9} listcount={10}/></> :
                    <TableContainer
                        columns={columns}
                        data={data?.booking ? data?.booking : []}
                        isGlobalFilter={true}
                        isAddOptions={false} //button enable
                        customPageSize={10}
                        iSPageOptions={true}
                        hiddenValue={getRole?.user?.role === 'CLIENT' ? ['clientCode', 'clientName'] : []}
                        className="custom-header-css"
                        btnname="Button name"
                        renderRowSubComponent={subTable}
                        expandRows
                        expandedRowObj={expandedRows}
                    />}
            </div>
        </div>
    )
}

export default BookingList